// Shared Vite entry for the ERB zones (marketing, auth, admin): boots
// Stimulus and registers every controller in app/frontend/controllers.
// Inertia/React pages use the separate inertia.tsx entry (ARCHITECTURE §7).
import { Application, type ControllerConstructor } from '@hotwired/stimulus'

const application = Application.start()

const controllers = import.meta.glob<{ default: ControllerConstructor }>(
  '../controllers/*_controller.ts',
  { eager: true },
)

for (const [path, controller] of Object.entries(controllers)) {
  const name = path
    .split('/')
    .pop()!
    .replace('_controller.ts', '')
    .replaceAll('_', '-')
  application.register(name, controller.default)
}
